import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getPartyStruct, setData } from './PartyStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './PartyAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updatePartyObj, addPartyObj, setShowEditForParty } from 'store/slice/PharmaSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import FieldView from 'core/components/layout/FieldView';



export default function PartyEditFormImpl() {
    const dispatch = useDispatch();
    const { setNotification, lastURL } = React.useContext(CoreContext);
    const [formValues, setFormValues] = useState(getPartyStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const { partyDashboard } = useSelector((state) => state.pharmaslice);
    const [partyId, setPartyId] = useState(partyDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)
    const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);

    const { partystatusList } = useSelector((state) => state.pharmaslice);
    

    const { apiInProgress } = useSelector((state) => state.headerslice)
    useEffect(() => {
    }, [apiInProgress])

    useEffect(() => {
        if (partyId !== -1) {
            if (dataLoaded) return;
            getAPI(partyId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }
        })
        console.log('formValues.statusname.value=>'+formValues.statusname.value)
        
    }, []);

    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const handleSameAddressRadioChange = (name, value) => {
        setShowError(false);
        setFormValues({
            ...formValues,
            ['sameaddress']: {
                ...formValues['sameaddress'],
                value: getRadioAPIvalue(value)
            },
            ['dispatchaddress']: {
                ...formValues['dispatchaddress'],
                value: getRadioAPIvalue(value)?formValues.address.value:''
            }
        })
       // updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        if (/[<>]/.test(value)) {
            setFormValues({
                ...formValues,
                [name]: {
                    ...formValues[name],
                    value,
                    error: true,
                    errorMessage: 'Characters < and > are not allowed.'
                }
            });
        } else {
            updateTextValue(formValues, setFormValues, e);
        }
    }
    const handleEmailChange = (e) => {
        setShowError(false);
        console.log(validEmailEntry(e));
        updateTextValue(formValues, setFormValues, e);
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const parsed = parseFloat(e.target.value);
        if (!isNaN(parsed) && e.target.value == parsed)
            updateTextValue(formValues, setFormValues, e);
    }
    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(addPartyObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForParty(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updatePartyObj(obj));
        setNotification('Record with id[' + partyId + '] has been updated successfully !!!');
        dispatch(setShowEditForParty(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback)
    }
    const callUpdateAPI = (id,formValues, updateSuccessCallback, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        updateAPI(id,formValues, updateSuccessCallback, failuerCallback);
    }

    const onSubmit = (e) => {
        handleSubmit(e, partyId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: 440 }}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{partyId === -1 ? 'Add' : 'Edit'} Party Information </Typography>
                                <Divider />
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="flex-start" alignItems="center">

                                    <Grid item lg={3} xs={12}>
                                        <TextField size="Normal"
                                            placeholder="Organization Name"
                                            required={formValues.title.required}
                                            label="Organization Name"
                                            name={formValues.title.name}
                                            value={formValues.title.value}
                                            onChange={handleTextChange}
                                            error={formValues.title.error}
                                            helperText={formValues.title.error && formValues.title.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    
                                    <Grid item lg={2} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.druglicense.placeholder}
                                            required={formValues.druglicense.required}
                                            label={formValues.druglicense.label}
                                            name={formValues.druglicense.name}
                                            value={formValues.druglicense.value}
                                            onChange={handleTextChange}
                                            error={formValues.druglicense.error}
                                            helperText={formValues.druglicense.error && formValues.druglicense.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={2} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.gst.placeholder}
                                            required={formValues.gst.required}
                                            label={formValues.gst.label}
                                            name={formValues.gst.name}
                                            value={formValues.gst.value}
                                            onChange={handleTextChange}
                                            error={formValues.gst.error}
                                            helperText={formValues.gst.error && formValues.gst.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={3} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.contact.placeholder}
                                            required={formValues.contact.required}
                                            label="Contact Person Name"
                                            name={formValues.contact.name}
                                            value={formValues.contact.value}
                                            onChange={handleTextChange}
                                            error={formValues.contact.error}
                                            helperText={formValues.contact.error && formValues.contact.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={2} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.contactmobile.placeholder}
                                            required={formValues.contactmobile.required}
                                            label="Contact Person Mobile"
                                            name={formValues.contactmobile.name}
                                            value={formValues.contactmobile.value}
                                            onChange={handleMobileChange}
                                            error={formValues.contactmobile.error}
                                            helperText={formValues.contactmobile.error && formValues.contactmobile.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={3} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.corporateemail.placeholder}
                                            required={formValues.corporateemail.required}
                                            label={formValues.corporateemail.label}
                                            name={formValues.corporateemail.name}
                                            value={formValues.corporateemail.value}
                                            onChange={handleEmailChange}
                                            error={formValues.corporateemail.error}
                                            helperText={formValues.corporateemail.error && formValues.corporateemail.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={7} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.address.placeholder}
                                            required={formValues.address.required}
                                            label={formValues.address.label}
                                            name={formValues.address.name}
                                            value={formValues.address.value}
                                            onChange={handleTextChange}
                                            error={formValues.address.error}
                                            helperText={formValues.address.error && formValues.address.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={2} xs={12}>
                                        <RadioForBoolean
                                            label="Same Dispatch Addess"
                                            fieldName={formValues.sameaddress.name}
                                            defaultValue={getRadioValue(formValues.sameaddress.value)}
                                            handleChange={handleSameAddressRadioChange}
                                        />
                                    </Grid>

                                    <Grid item lg={10} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.dispatchaddress.placeholder}
                                            required={formValues.dispatchaddress.required}
                                            label={formValues.dispatchaddress.label}
                                            name={formValues.dispatchaddress.name}
                                            value={formValues.dispatchaddress.value}
                                            onChange={handleTextChange}
                                            error={formValues.dispatchaddress.error}
                                            helperText={formValues.dispatchaddress.error && formValues.dispatchaddress.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    {formValues.statusname.value==='APPROVED'?
                                    <Grid item lg={2} xs={12}>
                                        <RadioForBoolean
                                            label="Active?"
                                            fieldName={formValues.status.name}
                                            defaultValue={getRadioValue(formValues.status.value)}
                                            handleChange={handleRadioChange}
                                        />
                                    </Grid>
                                    :<></>
                                    }
                                    
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.statusname.placeholder}
                                            required={formValues.statusname.required}
                                            label={formValues.statusname.label}
                                            name={formValues.statusname.name}
                                            value={formValues.statusname.value}
                                            onChange={handleTextChange}
                                            error={formValues.statusname.error}
                                            helperText={formValues.statusname.error && formValues.statusname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', }}
                                        />
                                    </Grid>
                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                {partyObj.statusname==="REFERRED BACK"?
                <Grid item lg={2} xs={6}><FieldView label="Rejection Reason"  value={ partyObj.rejectionreason }/></Grid>
                
                :<></>}
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{partyId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForParty(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
        </form>
    );
};